import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  constructor(private router: Router,
              private userService: UserService) {}

  goBack(): void {
    if (this.userService.isSignedIn()) {
      this.router.navigate(['/order']);
    } else {
      this.router.navigate(['/auth']);
    }
  }
}
